<template>
  <documents-delete-table-component
    :headings="headings"
    :documents="documents"
    :actionItems="reviewResults">
      <div
        slot-scope="{ actionItem }"
        v-if="actionItem.isNotOK()"
        class="is-pulled-right review-actions customer">
        <button
          class="button check is-outlined radius-circle"
          :class="[ actionItem.finding.hasAnsweredFinding() ? 'is-info' : 'is-danger' ]"
          @click="$emit('showFinding', actionItem)">
          <span class="icon is-medium">
            <i class="mdi mdi-exclamation"></i>
          </span>
        </button>
      </div>
  </documents-delete-table-component>
</template>
<script>
  import { ReviewResult } from '@/classes/case/ReviewResult'
  import { Document } from '@/classes/case/Document'
  import DocumentsDeleteTableComponent from '@/components/layout/utility/DocumentsDeleteTableComponent'

  export default {
    name: 'review-customer-documents-component',
    components: {
      DocumentsDeleteTableComponent
    },
    data () {
      return {
        headings: {
          col1: { name: 'Documents', classes: 'is-3-tablet is-4-desktop' },
          col2: { name: 'Filename', classes: 'is-3-tablet is-4-desktop' },
          col3: { name: 'Uploaded', classes: 'is-3-tablet is-2-desktop' },
          col4: { name: '', classes: 'is-3-tablet is-2-desktop' }
        }
      }
    },
    props: {
      reviewResults: {
        type: Array,
        validator: (prop) => prop.every(e => e instanceof ReviewResult),
        required: true
      }
    },
    computed: {
      documents () {
        return this.reviewResults.map(result => {
          return new Document(result.getLabel(), result.value)
        })
      }
    }
  }
</script>
<style lang="sass" scoped>
</style>
